// extracted by mini-css-extract-plugin
module.exports = {"normal_input":"NormalInput_normal_input__2Sx8P","readonly":"NormalInput_readonly__2011I"};